<div class="space-y-6">

  <!-- Profile information -->
  <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
    <div class="border-b border-slate-200 px-6 py-4">
      <h2 class="text-sm font-semibold text-slate-900">Profile</h2>
      <p class="mt-0.5 text-xs text-slate-500">Your account information pulled from Cognito and your user record.</p>
    </div>
    <div class="divide-y divide-slate-100">
      <div class="px-6 py-4">
        <p class="mb-0.5 text-xs font-medium uppercase tracking-wide text-slate-400">Name</p>
        <p class="text-sm font-medium text-slate-900">{{ displayName$ | async }}</p>
      </div>
      <div class="px-6 py-4">
        <p class="mb-0.5 text-xs font-medium uppercase tracking-wide text-slate-400">Email</p>
        <p class="text-sm font-medium text-slate-900">{{ (profile$ | async)?.email || '—' }}</p>
      </div>
      <div class="px-6 py-4">
        <p class="mb-0.5 text-xs font-medium uppercase tracking-wide text-slate-400">User ID</p>
        <p class="font-mono text-xs text-slate-400">{{ userId || '—' }}</p>
      </div>
    </div>
  </div>

  <!-- Update email -->
  <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
    <div class="border-b border-slate-200 px-6 py-4">
      <h2 class="text-sm font-semibold text-slate-900">Update Email</h2>
      <p class="mt-0.5 text-xs text-slate-500">
        Request an email address change.
        <span class="font-medium text-amber-600">This is a stub — no confirmation email is sent until the backend endpoint is wired up.</span>
      </p>
    </div>
    <div class="px-6 py-5">

      <div *ngIf="emailSuccess" class="mb-4 flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3">
        <lucide-icon name="circle-check" [size]="15" class="mt-0.5 flex-shrink-0 text-emerald-500" [strokeWidth]="2"></lucide-icon>
        <p class="text-sm text-emerald-700">{{ emailSuccess }}</p>
      </div>

      <div *ngIf="emailError" class="mb-4 flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
        <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
        <p class="text-sm text-red-700">{{ emailError }}</p>
      </div>

      <div class="flex items-end gap-3">
        <div class="flex-1">
          <label for="new-email" class="mb-1.5 block text-xs font-medium text-slate-700">New email address</label>
          <input
            id="new-email"
            type="email"
            name="newEmail"
            [(ngModel)]="newEmail"
            placeholder="new@example.com"
            class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 transition-shadow focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100"
          />
        </div>
        <button
          (click)="updateEmail()"
          [disabled]="emailLoading || !newEmail.trim()"
          class="flex items-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <lucide-icon *ngIf="emailLoading" name="loader" [size]="15" class="animate-spin" [strokeWidth]="2.5"></lucide-icon>
          {{ emailLoading ? 'Sending...' : 'Update email' }}
        </button>
      </div>
    </div>
  </div>

</div>
